import type { TFunction } from 'i18next';
import type { Role, SidebarNav, SidebarNavItem } from '../types/common';
import useSidebarNavItems from '../hooks/useSidebarNavItems';

/**
 * ロールを受け取ってサイドバーのコンテンツ配列を返す
 * @param [Role]
 * @param [t]
 * @return [SidebarNavItem[]]
 */
const getSidebarNavItems = ({ role, t }: { role: Role; t: TFunction<'translation', undefined> }) => {
  const navItems: SidebarNavItem[] = useSidebarNavItems(t);
  const filteredNavItems: SidebarNavItem[] = navItems.reduce((acc, cur) => {
    const filteredItems: SidebarNav[] = cur.items.filter((item) => item.role.includes(role));
    if (filteredItems.length) {
      const newNav: SidebarNavItem = { title: cur.title, items: filteredItems };
      return [...acc, newNav];
    } else {
      return acc;
    }
  }, []);
  // console.log(filteredNavItems);
  return filteredNavItems;
};

export default getSidebarNavItems;
